module.exports = __webpack_public_path__ + "7d475ada84bac4b50f483a65e27c9b1a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GW.svg
// module id = MNVd
// module chunks = 0